
import * as icons from '@mdi/js'

export default {
  components: {},
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  icons,
  computed: {

  },
  methods: {
    getIcon (item) {
      // eslint-disable-next-line
      return icons[item.icon] ?? "$checkedNew"
    }
  }
}
